"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const i18n = require("@ms/yammer-i18n");
const safeStrs={navigationCommunitiesNoFavoritesV2:1,navigationCommunitiesListRejectedErrorText:1};
exports.default = i18n.getStringInterpolator(safeStrs, 'navigation');
